import { Injectable } from '@angular/core';
import { BaseProvider } from 'src/app/core/services/base-provider';
import { HttpClient } from '@angular/common/http';
import { GlobalsService } from './globals.service';

@Injectable({
  providedIn: 'root'
})
export class SettingService extends BaseProvider {

  constructor(public globals: GlobalsService,
    public http: HttpClient) { 
      super();
      this.baseUrl = "setting";
  }

  getLogoHeader(){
    return new Promise( (resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + `/logo`;

        this.http
        .get(
          this.url
        )
        .subscribe(
            (data: any) => {
                resolve(data.Data);
            },
            err => {reject(err)}
        );
    });  
  }
}
